import { ColDef } from 'ag-grid-community';
import { fundsAtom } from '../../../services/state/AppConfigStateJ';
import { ColumnMeta } from '../../../types';
import { compareBySortOrderThenName } from '../../../util/comparators';
import { getForesightStore } from '../../../util/jotai-store';

export function getGroupMap(columns: ColumnMeta[]) {
  const columnGroupMap = columns.reduce((map, col) => {
    if (!map.has(col.groupName)) {
      map.set(col.groupName, []);
    }
    map.get(col.groupName)?.push(col);
    return map;
  }, new Map<string, ColumnMeta[]>());

  return columnGroupMap;
}

export function columnSort(a: ColumnMeta, b: ColumnMeta) {
  if (a.groupName === b.groupName) {
    return Number(a.groupPriority) - Number(b.groupPriority);
  }
  return Number(a.groupOrder) - Number(b.groupOrder);
}

// Fund groups (and the Fund column) sort by sortOrder, then name; values not in fundsAtom sort last.
export function createFundNameComparator(): ColDef['comparator'] {
  const store = getForesightStore();
  const fundsByName = new Map(store.get(fundsAtom).map((fund) => [fund.name, fund]));

  return (valueA: string, valueB: string) =>
    compareBySortOrderThenName(
      fundsByName.get(valueA) ?? { name: valueA },
      fundsByName.get(valueB) ?? { name: valueB }
    );
}
